/* pooch-cardhover.js — 12 Oct
   Kaam: product card par mouse le jaao to doosri photo aati hai, hatao to pehli wapas.
   Kabhi-kabhi (tez mouse, scroll karte waqt, page ke neeche naye card judne par) theme ka
   "wapas pehli photo" chook jaata tha aur card doosri photo par atka reh jaata tha.
   Ye file sirf itna dekhti hai: jis card se mouse hat chuka hai, wo pehli photo par hi ho.
   Phone (touch) par kuch nahi karti — wahan grahak khud swipe karta hai.

   Band karna ho: snippets/stylesheets.liquid me is file ka script tag hata do. */
(function () {
  var last = null;

  function firstSlide(g) {
    if (!g || !g.isConnected) return;
    if (g.matches(':hover')) return;                    // mouse abhi bhi isi par hai
    var card = g.closest('product-card');
    if (card && card.querySelector('swatches-variant-picker-component')) return; // rang/variant wale card: theme khud sambhale
    var ss = g.querySelector('slideshow-component');
    if (!ss || !ss.slides || !ss.slides.length) return;
    var sc = ss.refs && ss.refs.scroller;
    if (ss.current === 0 && (!sc || sc.scrollLeft < 1)) return; // pehle se theek
    ss.select(0, undefined, { animate: false });
    if (sc && sc.scrollLeft >= 1) sc.scrollLeft = 0;
  }

  function check(g) {
    // theme ka apna reset pehle chalne do, phir dekho
    setTimeout(function () { firstSlide(g); }, 120);
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var g = e.target && e.target.closest ? e.target.closest('.card-gallery') : null;
    if (g === last) return;
    if (last) check(last);
    last = g;
  }, { passive: true });

  // mouse browser se bahar
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse' || e.relatedTarget || !last) return;
    check(last);
    last = null;
  }, { passive: true });
})();
